export default "__VITE_ASSET__CcWJnPqZ__"